import React, { useState } from "react";

import { useRecoilState, useRecoilValue } from "recoil";

import Collapse from "@mui/material/Collapse";

import {
  layerDefColourStateSelector,
  layerDefFilterByChildrenSelector,
  layerDefFilterStateSelector,
} from "../map/layerAtoms";

import CheckboxParent from "./CheckboxParent";
import TransparencySlider from "./TransparencySlider";
import { ChildCheckbox } from "./ChildCheckbox";

export default function LayerCheckboxList({ layerID }) {
  const filterByChildren = useRecoilValue(
    layerDefFilterByChildrenSelector(layerID)
  );
  const [filterState, setFilterState] = useRecoilState(
    layerDefFilterStateSelector(layerID)
  );
  const colourState = useRecoilValue(layerDefColourStateSelector(layerID));
  const [collapseOpen, setCollapseOpen] = useState(false);
  const handleChange = (event, id) => {
    setFilterState((oldFilterState) => {
      return { ...oldFilterState, [id]: event.target.checked };
    });
  };
  const switchCollapseState = () => {
    setCollapseOpen((oldCollapseOpen) => !oldCollapseOpen);
  };

  return (
    <div>
      <CheckboxParent
        layerID={layerID}
        {...{
          switchCollapseState: switchCollapseState,
          collapseOpen: collapseOpen,
        }}
      />
      <Collapse in={collapseOpen}>
        {filterByChildren && (
          <ChildCheckbox
            filterState={filterState}
            colourState={colourState}
            handleChange={handleChange}
          />
        )}

        <TransparencySlider layerID={layerID} />
      </Collapse>
    </div>
  );
}
